import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'chartsSatisfaction',
    label: 'Group & Program Satisfaction Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
